import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgXTwitter = function SvgXTwitter(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 121"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#1C1C1B",
        d: "M119.992 60.018c0 30.311-22.463 55.371-51.643 59.437a61 61 0 0 1-8.353.576c-3.271 0-6.483-.261-9.61-.765C21.818 114.665 0 89.888 0 60.018 0 26.872 26.864 0 60 0s60 26.872 60 60.018z"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m24.333 26.468 27.67 37.006-27.843 30.09h6.268l24.38-26.343 19.696 26.342H95.83L66.604 54.475l25.918-28.007h-6.268l-22.45 24.26-18.14-24.26H24.332m9.215 4.617h9.795l43.264 57.86H76.81z"
    })));
};

export { SvgXTwitter as ReactComponent };
//# sourceMappingURL=X-Twitter.svg.es.js.map
